import React, {useState} from "react"
import Select from "react-select"
import {useGetEquipmentCategoriesQuery} from "../../../api/equipment"
import {useTranslation} from "react-i18next"


const ALL_CATEGORIES = "All categories"

export const LeftCategories = ({setCategory}) => {
    const { t } = useTranslation("common")
    const [isFree, setIsFree] = useState(false)

    const handleClick = (equipmentIsFree) => {
        setIsFree(equipmentIsFree)
        if (equipmentIsFree) setCategory({free: true})
        setCategory(
            equipmentIsFree ? {free: true} : {}
        )
    }

    return (
        <div className="equipment-header-categories-box">
            <button type="button" onClick={() => handleClick(false)}
                className={`table-category ${!isFree ? "table-category-selected t-s3" : "t-s4"}`}>
                {t("All")}
            </button>
            <button type="button" onClick={() => handleClick(true)}
                className={`table-category ${isFree ? "table-category-selected t-s3" : "t-s4"}`}>
                {t("Unassigned")}
            </button>
        </div>
    )
}

export const RightCategories = ({category, setCategory}) => {
    const { t } = useTranslation("common")

    const {data } = useGetEquipmentCategoriesQuery({})
    const categories = data?.items?.map((value) => value.name) || []

    return (
        <Select
            isSearchable={false}
            components={{
                IndicatorSeparator: () => null
            }}
            options={categories.map((category) => ({value: category, label: category}))}
            defaultValue={[ALL_CATEGORIES, ...categories].category ? {value: category.category, label: category.category} : {value: ALL_CATEGORIES, label: t(ALL_CATEGORIES)}}
            onChange={(typeCategory) => setCategory(typeCategory.value !== ALL_CATEGORIES ? {category: typeCategory.value} : {})}
            classNamePrefix="custom-select t-s1 equipment-category-react-select"
        />
    )
}
